import { render } from "./Integrations.vue?vue&type=template&id=81227fbc&scoped=true"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"

import "./Integrations.vue?vue&type=style&index=0&id=81227fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81227fbc"]])

export default __exports__